export default __webpack_public_path__ + "static/heater_b.f97f64eb443339fda47582f9eaf4842e.png";